//====================================================
//  Function: Gallery
//====================================================
function fn_components_gallery(){
	// if ($( '.gallery-block' ).length){
	// 	$( '.gallery-block' ).lightGallery({
	// 		selector: '.item'
	// 	});
	// }

	if ($( '.js-gallery' ).length){
		$( '.js-gallery .js-gallery-image' ).touchTouch();

	}
}